import type { ReactNode } from 'react';
import { BADGE_TYPES, BadgeType } from '@/constants/common.constants';
import './badge-style.scss';

interface BadgeProps {
  text: ReactNode;
  type?: BadgeType;
  style?: {
    backgroundColor?: string;
    color?: string;
  };
}

const Badge = ({ text, type = BADGE_TYPES.INFO, style }: BadgeProps) => {
  // Color config based on type (matching toast/alert logic)
  const badgeColorConfig = {
    [BADGE_TYPES.SUCCESS]: {
      backgroundColor: 'var(--success-light-1)',
      color: 'var(--success-dark-1)',
    },
    [BADGE_TYPES.DANGER]: {
      backgroundColor: 'var(--danger-light-1)',
      color: 'var(--danger-dark-1)',
    },
    [BADGE_TYPES.WARNING]: {
      backgroundColor: 'var(--warning-light-1)',
      color: 'var(--warning-dark-1)',
    },
    [BADGE_TYPES.INFO]: {
      backgroundColor: 'var(--info-light-1)',
      color: 'var(--info-dark-1)',
    },
    [BADGE_TYPES.NEUTRAL]: {
      backgroundColor: 'var(--neutral-light-2)',
      color: 'var(--neutral-dark-1)',
    },
  };

  // Get color config based on type if style is not provided
  const colorConfig =
    badgeColorConfig[type] || badgeColorConfig[BADGE_TYPES.INFO];

  // Use explicit style if provided, otherwise use type-based colors
  const badgeStyle = style || {
    backgroundColor: colorConfig.backgroundColor,
    color: colorConfig.color,
  };

  return (
    <span className="badge" style={badgeStyle}>
      {text}
    </span>
  );
};

export { Badge };
